import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faRedoAlt } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

export default function OverrideButton({ disabled, onRemove, onReset }) {
  if (disabled) {
    return (
      <Tooltip content="Override this option to specify your own defaults">
        <a className="text-muted clickable" name="override-default" onClick={onReset}>
          <FontAwesomeIcon icon={faEdit}/> Click to Override
        </a>
      </Tooltip>
    );
  }

  return (
    <Tooltip content="Revert to designer specified defaults">
      <a className="clickable" name="use-default" onClick={onRemove}>
        <FontAwesomeIcon icon={faRedoAlt}/> Reset to Buildout Default
      </a>
    </Tooltip>
  );
}

OverrideButton.propTypes = {
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired
};
